module.exports = function ($q, resourceInjector) {
    return function getGoogleMapsApi(url) {
        return $q((resolve) => {
            url = `${url}&callback=onGoogleMapsReady`;

            if (resourceInjector.isScriptInjected(url) && window.google && window.google.maps) {
                resolve(window.google);
            }

            window.onGoogleMapsReady = function () {
                delete window.onGoogleMapsReady;
                resolve(window.google);
            };

            resourceInjector.injectScript(url);
        });
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-maps-api-factory.js